export default __webpack_public_path__ + "static/media/piece2.7020138f.png";